/* Map & Memoir cart drawer. Config comes from #mnm-cart-config (written by sections/mnm-global.liquid). */
(function () {
  if (window.mnmCart) return;
  var root = document.getElementById('mnm-cart');
  if (!root) return;
  var cfgEl = document.getElementById('mnm-cart-config');
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }

  var $ = function (s, r) { return (r || root).querySelector(s); };
  var money = function (p) { return '₹' + Math.round(p / 100).toLocaleString('en-IN'); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); };
  var img = function (src, w) { return src ? src.replace(/(\.(jpg|jpeg|png|webp))(\?.*)?$/i, '_' + w + 'x$1') : ''; };

  var itemsEl = $('[data-mnm-items]'), subEl = $('[data-mnm-sub]'), countEl = $('[data-mnm-count]'),
      emptyEl = $('[data-mnm-empty]'), footEl = $('[data-mnm-foot]'), addonEl = $('[data-mnm-addon-card]'),
      upsellEl = $('[data-mnm-upsell]'), recsEl = $('[data-mnm-recs]'), etaEl = $('[data-mnm-eta]'),
      giftWrap = $('[data-mnm-giftwrap]'), giftBox = $('[data-mnm-giftbox]'), giftText = $('[data-mnm-gifttext]');
  var lastFocus = null, cart = null;

  function open() {
    lastFocus = document.activeElement;
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refresh();
    var c = $('.mnmc__close'); if (c) c.focus();
  }
  function close() {
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function busy(on) { root.classList.toggle('mnmc__busy', !!on); }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(render);
  }

  function render(c) {
    cart = c;
    countEl.textContent = c.item_count === 1 ? '1 item' : c.item_count + ' items';
    var bubble = document.querySelector('.cart-count-bubble span:first-child');
    if (bubble) bubble.textContent = c.item_count;

    if (!c.items.length) {
      itemsEl.innerHTML = '';
      emptyEl.hidden = false; footEl.hidden = true;
      if (addonEl) addonEl.hidden = true;
      if (upsellEl) upsellEl.hidden = true;
      return;
    }
    emptyEl.hidden = true; footEl.hidden = false;

    itemsEl.innerHTML = c.items.map(function (i, idx) {
      var props = Object.keys(i.properties || {}).filter(function (k) { return k.charAt(0) !== '_' && i.properties[k]; })
        .map(function (k) { return esc(k) + ': ' + esc(i.properties[k]); }).join('<br>');
      return '<div class="mnmc__line" data-line="' + (idx + 1) + '">' +
        '<a href="' + esc(i.url) + '"><img src="' + esc(img(i.featured_image && i.featured_image.url, 160)) + '" alt="" width="72" height="72" loading="lazy"></a>' +
        '<div><div class="mnmc__lineTop"><a class="mnmc__lineT" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' +
        '<span class="mnmc__lineP">' + money(i.final_line_price) + '</span></div>' +
        (i.variant_title && i.variant_title !== 'Default Title' ? '<div class="mnmc__lineMeta">' + esc(i.variant_title) + '</div>' : '') +
        (props ? '<div class="mnmc__lineMeta">' + props + '</div>' : '') +
        '<div class="mnmc__lineBot"><span class="mnmc__qty">' +
        '<button type="button" data-mnm-qty="-1" aria-label="Reduce quantity of ' + esc(i.product_title) + '">−</button>' +
        '<span>' + i.quantity + '</span>' +
        '<button type="button" data-mnm-qty="1" aria-label="Increase quantity of ' + esc(i.product_title) + '">+</button></span>' +
        '<button type="button" class="mnmc__rm" data-mnm-remove aria-label="Remove ' + esc(i.product_title) + '">Remove</button></div></div></div>';
    }).join('');

    subEl.textContent = money(c.total_price);

    var ids = c.items.map(function (i) { return i.product_id; });
    if (addonEl && cfg.addon) addonEl.hidden = ids.indexOf(cfg.addon.product_id) !== -1;
    if (upsellEl && cfg.upsell) {
      var show = ids.indexOf(cfg.upsell.trigger_id) !== -1 && ids.indexOf(cfg.upsell.product_id) === -1;
      upsellEl.hidden = !show;
    }
    if (recsEl) {
      var recs = (cfg.recs || []).filter(function (p) { return ids.indexOf(p.product_id) === -1; }).slice(0, 6);
      recsEl.hidden = !recs.length;
      var row = $('[data-mnm-recrow]');
      if (row) row.innerHTML = recs.map(function (p) {
        return '<div class="mnmc__rec"><a href="' + esc(p.url) + '"><img src="' + esc(img(p.image, 240)) + '" alt="" width="120" height="120" loading="lazy"></a>' +
          '<span>' + esc(p.title) + '</span><span class="mnmc__lineP">' + money(p.price) + '</span>' +
          '<button type="button" data-mnm-add="' + p.variant_id + '">+ Add</button></div>';
      }).join('');
    }
    if (giftBox && c.note) { giftBox.checked = true; if (giftWrap) giftWrap.hidden = false; if (giftText) giftText.value = c.note; }

    if (etaEl) {
      var pin = '';
      try { pin = localStorage.getItem('mnm_pin') || ''; } catch (e) {}
      etaEl.textContent = pin ? 'Delivering to ' + pin + ' · ' + cfg.eta_text : cfg.eta_text;
    }
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-mnm-close]') || t.classList.contains('mnmc__overlay')) return close();

    var qty = t.closest('[data-mnm-qty]');
    if (qty) {
      var line = Number(qty.closest('[data-line]').dataset.line);
      var now = cart.items[line - 1].quantity + Number(qty.dataset.mnmQty);
      busy(true);
      return post('/cart/change.js', { line: line, quantity: Math.max(0, now) }).then(render).finally(function () { busy(false); });
    }
    var rm = t.closest('[data-mnm-remove]');
    if (rm) {
      var l = Number(rm.closest('[data-line]').dataset.line);
      busy(true);
      return post('/cart/change.js', { line: l, quantity: 0 }).then(render).finally(function () { busy(false); });
    }
    var add = t.closest('[data-mnm-add]');
    if (add) {
      busy(true);
      return post('/cart/add.js', { items: [{ id: Number(add.dataset.mnmAdd), quantity: 1 }] }).then(refresh).finally(function () { busy(false); });
    }
    var co = t.closest('[data-mnm-checkout]');
    if (co) {
      e.preventDefault();
      if (typeof window.onCheckoutClick === 'function') return window.onCheckoutClick(co);
      window.location.href = '/checkout';
    }
  });

  if (giftBox) giftBox.addEventListener('change', function () {
    if (giftWrap) giftWrap.hidden = !giftBox.checked;
    if (giftBox.checked && giftText) giftText.focus();
    if (!giftBox.checked) post('/cart/update.js', { note: '' });
  });
  if (giftText) {
    var t0;
    giftText.addEventListener('input', function () {
      clearTimeout(t0);
      t0 = setTimeout(function () { post('/cart/update.js', { note: giftText.value.trim() }); }, 600);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (root.getAttribute('aria-hidden') === 'true') return;
    if (e.key === 'Escape') return close();
    if (e.key !== 'Tab') return;
    var f = root.querySelectorAll('a[href], button:not([disabled]), textarea, input, [tabindex]:not([tabindex="-1"])');
    var list = [].filter.call(f, function (el) { return el.offsetParent !== null; });
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Cart links and the header cart icon open this drawer.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="/cart"], a[href*="/cart?"], #cart-icon-bubble, [href="#cart"]');
    if (!a) return;
    e.preventDefault(); e.stopPropagation();
    open();
  }, true);

  // The theme's bought-in side cart stays out of the way.
  document.documentElement.classList.add('mnmc-hide-sme');
  window.openSmeCart = function () { open(); };
  window.closeSmeCart = function () { close(); };

  window.mnmCart = { open: open, close: close, refresh: refresh };
  refresh();
})();
